<div id="home-wrapper">
    <!-- app-header -->
    <p-confirmDialog styleClass="pn-confirm-dialog"></p-confirmDialog>
    <p-toast  position="top-center" [preventOpenDuplicates]="true">
        <ng-template let-message pTemplate="message">
            <div class="ui-toast-message-text-content">
                <div class="ui-toast-detail" [innerHTML]="sanitizedToastDetail"></div>
            </div>
        </ng-template>
    </p-toast>
    <div *ngIf="isOffline" class="offline-block">
        <span class="offline-status"><i
                class="pi pi-exclamation-triangle offline-warning-icon"></i>{{offlineStatusMessage}}</span>
    </div>
    <app-actionbar (appOptionsStatus)="appOptionsStatus($event)" [hideAppOptions]="hideAppOptions"></app-actionbar>
    <div #content  class="wrapper">
        <!-- overlay here -->
        <div id="content" class="content">
            <div class="container-fluid p-0 h-100">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <app-loader></app-loader>
</div>